import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Heading, Icon, Button } from 'components/chroma';

const Container = styled.div`
  padding-top: 16px;
  margin-left: 8px;
  display: flex;
  justify-content: space-between;

  border-top: 1px dotted ${THEME.CARD.BORDER};
`;

interface SummaryCardProps {
  heading: string;
  onEditClick?: Function;
}

const SummaryCard: FunctionComponent<SummaryCardProps> = ({
  heading,
  children,
  onEditClick,
}) => (
  <Container>
    <div>
      <Heading size={5} margin={{ bottom: 1 }}>
        {heading}
      </Heading>
      {children}
    </div>
    {onEditClick && (
      <Button tertiary ariaLabel={`Edit ${heading}`} onClick={onEditClick}>
        <Icon name="pen" />
      </Button>
    )}
  </Container>
);

export default SummaryCard;
